'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import styled from 'styled-components';
import { H4, H7 } from 'UIComponents/elements/headings';
import UIImage from 'UIComponents/image/UIImage';
import UIMedia from 'UIComponents/layout/UIMedia';
import UIMediaBody from 'UIComponents/layout/UIMediaBody';
import UIMediaLeft from 'UIComponents/layout/UIMediaLeft';
import UIMediaRight from 'UIComponents/layout/UIMediaRight';
import UIIcon from 'UIComponents/icon/UIIcon';
import AccordionTransition from 'UIComponents/transitions/AccordionTransition';
import UITruncateMultiline from 'UIComponents/text/UITruncateMultiline';
import useMediaQuery from '../../../hooks/useMediaQuery';
import { device } from '../../../constants/StyledComponentConstants';
const ArrowBox = styled.div.withConfig({
  displayName: "ProfessorCard__ArrowBox",
  componentId: "xa1rwf-0"
})(["display:flex;align-items:center;justify-content:flex-end;"]);
const ProfessorCardWrapper = styled.div.withConfig({
  displayName: "ProfessorCard__ProfessorCardWrapper",
  componentId: "xa1rwf-1"
})(["&:not(:last-child){margin-bottom:20px;}width:calc((min(850px,100vw) - 64px) * ", ");overflow:hidden;@media screen and ", "{width:auto;}"], props => props.widthRatio, device.mobile);
const ProfessorImage = styled(UIImage).withConfig({
  displayName: "ProfessorCard__ProfessorImage",
  componentId: "xa1rwf-2"
})(["height:60px !important;width:60px !important;object-fit:cover;border-radius:3px;"]);

const ProfessorCard = ({
  name,
  description,
  imageUrl,
  widthRatio = 1
}) => {
  const isMobile = useMediaQuery(`screen and ${device.mobile}`);
  const [isExpanded, setIsExpanded] = useState(false);
  const NameComponent = isMobile ? H7 : H4;
  return /*#__PURE__*/_jsxs(ProfessorCardWrapper, {
    onClick: () => isMobile && setIsExpanded(bool => !bool),
    widthRatio: widthRatio,
    children: [/*#__PURE__*/_jsxs(UIMedia, {
      align: "center",
      children: [/*#__PURE__*/_jsx(UIMediaLeft, {
        children: /*#__PURE__*/_jsx(ProfessorImage, {
          height: 60,
          src: imageUrl,
          width: 60
        })
      }), /*#__PURE__*/_jsx(UIMediaBody, {
        children: /*#__PURE__*/_jsx(NameComponent, {
          className: "m-bottom-0",
          children: name
        })
      }), isMobile && /*#__PURE__*/_jsx(UIMediaRight, {
        children: /*#__PURE__*/_jsx(ArrowBox, {
          children: /*#__PURE__*/_jsx(UIIcon, {
            name: isExpanded ? 'up' : 'down',
            style: {
              position: 'relative',
              top: '1px'
            }
          })
        })
      })]
    }), /*#__PURE__*/_jsx(AccordionTransition, {
      open: !isMobile || isExpanded,
      children: /*#__PURE__*/_jsx("div", {
        className: "m-bottom-0 m-top-4",
        children: /*#__PURE__*/_jsx(UITruncateMultiline, {
          maxChars: 500,
          text: description || ''
        })
      })
    })]
  });
};

export default ProfessorCard;